import {
    type ViewStyle,
    StyleSheet
} from "react-native";
import type {
    DataTableSortButtonDynamicStyleType
} from "./type";
import type {
    Mutable
} from "../../../../types";
import {
    getFocusRingStyle
} from "../../../../helpers/theme/state";
import {
    getCornerStyle
} from "../../../../helpers/theme/corner";
import {
    getHitArea
} from "../../../../helpers/theme/control";
import {
    webStyle
} from "../../../../utils";

const stylesheet = StyleSheet.create({
    icon: {
        justifyContent: "center",
        alignItems: "center"
    },
    container: {
        justifyContent: "center"
    },
    surface: {
        alignItems: "center"
    }
});

export const useStyles = ({
    isFocusVisible,
    shapeConfigs,
    touchTargets,
    headVariant,
    pointerType,
    typography,
    radiuses,
    borders,
    colors,
    spaces
}: DataTableSortButtonDynamicStyleType) => {
    const visualHeight = Number(typography[headVariant].lineHeight ?? 0) + spaces.spacingXs * 2;

    const styles = {
        surface: {
            paddingHorizontal: spaces.spacingXs,
            ...getCornerStyle({
                radius: radiuses.actions,
                shapeConfigs
            }),
            gap: spaces.spacingXs,
            flexDirection: "row",
            height: visualHeight,
            ...getFocusRingStyle({
                isFocusVisible,
                borders,
                colors
            })
        } as Mutable<ViewStyle>,
        container: {
            ...getHitArea({
                visualSize: visualHeight,
                pointerType,
                touchTargets
            }),
            marginHorizontal: -spaces.spacingXs,
            ...webStyle({
                outlineStyle: "solid",
                outlineWidth: 0
            })
        } as Mutable<ViewStyle>
    };

    return styles;
};
export default stylesheet;
